import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import enTranslations from './locales/en.json';
import frTranslations from './locales/fr.json';
import esTranslations from './locales/es.json';
import itTranslations from './locales/it.json';
import deTranslations from './locales/de.json';
import cnTranslations from './locales/cn.json';

// Get initial language from URL first, then localStorage, then default to 'en'
const getInitialLanguage = () => {
  // Check URL first
  if (typeof window !== "undefined") {
    const urlParams = new URLSearchParams(window.location.search);
    const langFromURL = urlParams.get("lang");
    if (langFromURL && ["en", "fr", "es", "it", "de", "cn"].includes(langFromURL)) {
      return langFromURL;
    }
  }
  // Fallback to localStorage
  const savedLanguage = localStorage.getItem('language');
  if (savedLanguage && ["en", "fr", "es", "it", "de", "cn"].includes(savedLanguage)) {
    return savedLanguage;
  }
  // Default to 'en'
  return 'en';
};

const savedLanguage = getInitialLanguage();

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: enTranslations,
      },
      fr: {
        translation: frTranslations,
      },
      es: {
        translation: esTranslations,
      },
      it: {
        translation: itTranslations,
      },
      de: {
        translation: deTranslations,
      },
      cn: {
        translation: cnTranslations,
      },
    },
    lng: savedLanguage, // default language
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    react: {
      useSuspense: false, // Disable suspense to prevent issues
    },
  });

// Listen for language changes in localStorage
if (typeof window !== 'undefined') {
  window.addEventListener('storage', (e) => {
    if (e.key === 'language' && e.newValue) {
      i18n.changeLanguage(e.newValue);
    }
  });
}

export default i18n;

